import React from "react";
import { Box, Typography, useTheme } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { PrimaryCustomButton } from "../components/CustomButtons/PrimaryCustomButton";
import { ButtonType } from "@BehpardazBarin/frontend_components";

export default function PageNotFound() {
  const theme = useTheme();
  const navigate = useNavigate();
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        minHeight: "100vh",
        backgroundColor: theme.customColors.neutral[70],
      }}
    >
      <Typography variant="h1" sx={{ color: "white", marginBottom: 2 }}>
        404
      </Typography>
      <Typography variant="h6" sx={{ color: "white", marginBottom: 10 }}>
        صفحه ای که به دنبال آن هستید وجود ندارد
      </Typography>
      <PrimaryCustomButton
        buttonType={ButtonType.actionButton}
        onClickHandler={() => navigate("/")}
        value="برگشت به خانه"
        customButtonStyle={{
          borderRadius: "12px",
          width: "40%",
          maxWidth: "300px",
          padding: "12px 0",
        }}
        textStyle={{
          fontFamily: "IRANSansX",
        }}
      />
    </Box>
  );
}
